import { render, staticRenderFns } from "./ChatRightInfo.vue?vue&type=template&id=51706f41&"
import script from "./ChatRightInfo.vue?vue&type=script&lang=js&"
export * from "./ChatRightInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChatRightInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports